var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReload = function SvgReload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "current",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#reload_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 14a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-5h-5a1 1 0 0 1-1-1ZM1 3a1 1 0 0 1 1 1v5h5a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.227 2.396a10 10 0 0 1 12.206 6.27 1 1 0 1 1-1.886.668A8 8 0 0 0 6.325 6.369l-4.64 4.36A1 1 0 0 1 .315 9.27l4.63-4.35a10 10 0 0 1 4.282-2.525Zm14.502 10.92a1 1 0 0 1-.044 1.413l-4.63 4.35a10 10 0 0 1-16.488-3.745 1 1 0 1 1 1.886-.668 8 8 0 0 0 13.213 2.974l.01-.009 4.64-4.36a1 1 0 0 1 1.413.044Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "reload_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%"
  })))));
};
export default SvgReload;